"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasSegmentation = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
var draw_paint_objects_1 = require("../functions/draw/draw-paint-objects");
var style = { width: '100%', height: '100%' };
exports.CanvasSegmentation = (0, react_1.memo)(function (_a) {
    var paintStyle = _a.paintStyle, canvasSize = _a.canvasSize, paintObjects = _a.paintObjects, mode = _a.mode;
    var _b = tslib_1.__read((0, utils_1.useCanvasContext2d)(), 2), context = _b[0], canvasRef = _b[1];
    (0, react_1.useEffect)(function () {
        if (context === undefined)
            return;
        if (canvasSize.width === 0 || canvasSize.height === 0)
            return;
        window.requestAnimationFrame(function () {
            var width = canvasSize.width, height = canvasSize.height;
            var pixel = context.createImageData(width, height); // 0 filled
            if (mode !== 'rectbox-editor-add-bbox' &&
                mode !== 'rectbox-editor-resize-bbox' &&
                mode !== 'auto-segmentation-crop') {
                var pixelAt_1 = function (x, y) { return 4 * (width * y + x); };
                /* canvasは色を頻繁に変えない方が描画が速いため，
                    同じ色のオブジェクトを連続して描いている */
                paintObjects
                    .groupBy(function (paintObjAll) { return paintObjAll.label; })
                    .forEach(function (paintObjectsGroupedByLabel, label) {
                    var e_1, _a;
                    var _b = tslib_1.__read(paintStyle.faceColorSLA, 3), s = _b[0], l = _b[1], a = _b[2];
                    var rgba = (0, utils_1.hslaToRgba)([label.hue, s, l, a]);
                    try {
                        for (var _c = tslib_1.__values(paintObjectsGroupedByLabel.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var paint = _d.value;
                            (0, draw_paint_objects_1.drawPaintObject)(pixel, paint, rgba, pixelAt_1);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                });
            }
            context.putImageData(pixel, 0, 0);
        });
    }, [context, paintStyle.faceColorSLA, canvasSize, mode, paintObjects]);
    return (react_1.default.createElement("canvas", { style: style, ref: canvasRef, height: canvasSize.height, width: canvasSize.width }));
});
exports.CanvasSegmentation.displayName = 'CanvasSegmentation';
